import React, { useEffect, useState } from 'react'
import Loader from "../layout/Loader";
import toast from "react-hot-toast";
import { Link, useNavigate, useParams } from "react-router-dom";
import AdminLayout from "../layout/AdminLayout";
import { useGetUserDetailQuery, useUpdateUserMutation } from '../../redux/api/userApi';

const UpdateUser = () => {

    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [role, setRole] = useState("");


    const navigate = useNavigate();
    const params = useParams()

    const { data, isLoading } = useGetUserDetailQuery(params?.id)

    const [UpdateUser, { error, isSuccess }] = useUpdateUserMutation()

    useEffect(() => {
        if (data?.user) {
            setName(data?.user?.name);
            setEmail(data?.user?.email);
            setRole(data?.user?.role);
        }
    }, [data])

    useEffect(() => {

        if (error) {
            toast.error(error?.data?.message);
        }
        if (isSuccess) {
            toast.success("User Updated");
            navigate("/admin/users");
        }
    }, [error, isSuccess, navigate]);

    const submitHandler = (e) => {
        e.preventDefault();

        const userData = {
            name,
            email,
            role,

        };

        UpdateUser({ id: params?.id, body: userData });
    };
    if (isLoading) return <Loader />

    return (
        <AdminLayout>
            <div className="row wrapper mt-0">
                <div className="col-12 col-lg-8 ">
                    <form className="product-card shadow-sm" onSubmit={submitHandler}>
                        <div className="d-flex justify-content-between align-items-center mb-3">
                            <h2 className="mb-0 text-center fw-bold" style={{ color: "#e04f6e" }}>Update User</h2>
                            <Link to="/admin/users" className="btn btn-sm btn-outline-secondary">Back</Link>
                        </div>

                        <div className="mb-3">
                            <label htmlFor="name_field" className="form-label" style={{ color: "#e04f6e" }}>Name</label>
                            <input
                                type="name"
                                id="name_field"
                                className="form-control"
                                name="name"
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                            />
                        </div>

                        <div className="mb-3">
                            <label htmlFor="email_field" className="form-label" style={{ color: "#e04f6e" }}>Email</label>
                            <input
                                type="email"
                                id="email_field"
                                className="form-control"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                            />
                        </div>

                        <div className="mb-3">
                            <label htmlFor="role_field" className="form-label" style={{ color: "#e04f6e" }}>Role</label>
                            <select id="role_field" className="form-select" name="role"
                                value={role}
                                onChange={(e) => setRole(e.target.value)}
                            >
                                <option value="user">user</option>
                                <option value="admin">admin</option>
                            </select>
                        </div>

                        <button type="submit" className="btn View-btn w-100 py-2 fw-semibold">
                            Update
                        </button>
                    </form>
                </div>
            </div>
        </AdminLayout>
    )
}

export default UpdateUser
